var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentsListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 18.25H22v2.5H6.5v-2.5zm0-5H22v2.5H6.5v-2.5zm0-5H22v2.5H6.5v-2.5zm0-5H22v2.5H6.5v-2.5zm-4.5 15h2.5v2.5H2v-2.5zm0-5h2.5v2.5H2v-2.5zm0-5h2.5v2.5H2v-2.5zm0-5h2.5v2.5H2v-2.5z",
  fill: "#545454"
}))));
export default SvgDocumentsListIcon;